<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">{{this.config.title}}</h1>
        </v-flex>
        <v-flex xs12>
          <transition name="fade">
            <v-card class="mb-3" style="border-radius: 10px;">
              <v-container fluid>
                <v-layout row wrap mx-3>
                  <v-flex xs12 sm7 py-0 pt-1>
                  </v-flex>
                  <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>
                    <div class="font-weight-thin">Registros: {{companies.length}}</div>
                  </v-flex>
                  <v-flex xs12 lg5 pa-0>
                    <v-radio-group v-model="search_mode">
                      <div slot="label">Buscar por:</div>
                      <div style="display: flex; align-items: baseline;">
                        <v-radio label="Nome" value="name_in"></v-radio>
                        <v-radio label="Número documento" value="document_number_prefix"></v-radio>
                        <v-radio label="Id cadastro" value="id"></v-radio>
                      </div>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 lg7 pl-2>
                    <div class="hidden-md-and-down">&nbsp;</div>
                    <v-text-field v-model="search_query" class="search-filter" append-icon="search" @keyup.enter="searchCompanies()"></v-text-field>
                  </v-flex>

                  <subject-item @onUpdate="onUpdate" @onReprove="onReprove" :record="company" v-for="company in companies" :key="company.id" />

                  <v-flex xs12 pt-0 mt-1 v-if="companiesLoaded == 'empty' || loading">
                    <v-layout row wrap>
                      <v-flex xs12 py-0>
                        <v-container py-3 px-0>
                          <v-layout row wrap>
                            <v-flex xs12 md8 text-xs-center text-sm-left>
                              <v-layout row wrap body-1>
                                <v-flex xs12 py-0 v-if="companiesLoaded == 'empty' && !loading">
                                  {{this.config.empty}}
                                </v-flex>
                                <v-flex xs12 py-0 v-if="loading">
                                  Buscando registros
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-container>
              <v-card-actions>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs6 pr-1>
                      <v-btn block dark class="font-weight-black btn-style" @click="cleanSearch">
                        {{ i18n("LIMPAR BUSCA") }}
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 pl-1>
                      <v-btn block dark class="font-weight-black flex-1 btn-bg-color text-color-white" @click="searchCompanies">
                        {{ i18n("BUSCAR") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import SubjectItem from "./SubjectItem"

export default {
  name: 'AdminSubjectsSearch',
  components: { layout: LeftBarLayout, 'subject-item': SubjectItem },
  data() {
    return {
      companies: [],
      companiesLoaded: 'not_loaded',
      search_query: '',
      search_mode: 'name_in',
      loading: false,
      config: {
        title: 'Buscar Cadastro',
        empty: 'Nenhum cadastro encontrado'
      }
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    cleanSearch(e) {
      this.companies = []
      this.companiesLoaded = 'not_loaded'
      this.search_query = ''
    },
    onUpdate(companies, record) {
      if ((record.clearance_level * 1) == 0) {
        companies.splice(companies.findIndex(el => el.id === record.id), 1)
      }
    },
    onReprove(companies, record) {
      companies.splice(companies.findIndex(el => el.id === record.id), 1)
    },
    searchCompanies() {
      if (this.search_query.trim() == '') {
        return false
      }

      let successCallback = (response) => {
        this.loading = false

        if (response.body.data) {
          this.companies = response.body.data

          if (this.companies.length === 0) {
            this.companiesLoaded = 'empty'
          } else {
            this.companiesLoaded = 'ok'
          }
        } else {
          this.companiesLoaded = 'error'
        }
      }

      let errorCallback = (response) => {
        this.loading = false

        if (response.status === 401) {
          this.companiesLoaded = 'not_authorized'
        } else {
          this.companiesLoaded = 'error'
        }
      }

      const mode = this.search_mode
      let s = this.search_query
      if (mode == 'document_number_prefix') {
        const isCpf = /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(s)
        const isCnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(s)
        if (isCpf || isCnpj) {
          s = s.replace(/[^0-9]/g,'')
        }
      }

      this.companies = []
      this.loading = true
      const token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin__search, { params: { s, mode }, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}

</script>
<style scoped>
.btn-bg-color {
  height: 56px!important;
  background-color: var(--secondary-button-background-color)!important;
}
</style>



// WEBPACK FOOTER //
// src/AdminSubjectsSearch.vue